export const contactsData = {
    email: 'dhalsmrutiranjan1996@gmail.com',
    phone: '+917008932764',
    address: 'Jajpur road, Odisha, India- 755026 ',

    sheetAPI: ''
}